import { ReactNode } from 'react';
import { Button, Typography } from '@/components/common';
import clsx from 'clsx';

interface Props {
	title: string;
	subtitleCustom?: ReactNode;
	className?: string;
	children: ReactNode;
	cancelDisabled?: boolean;
	saveDisabled?: boolean;
	formId?: string;
	onClickSave: () => void;
	onClickCancel: () => void;
}

export const Template: React.FC<Props> = ({
	title,
	subtitleCustom,
	className,
	onClickSave,
	onClickCancel,
	cancelDisabled,
	saveDisabled,
	children,
	formId,
}) => {
	return (
		<div className="bg-white md:border md:border-[#0D061614] md:p-8 md:rounded-3xl">
			<form className={clsx(className)} onSubmit={onClickSave} id={formId}>
				<div className="sticky top-12 md:top-[58px] z-10 bg-white flex flex-col sm:flex-row items-start sm:items-center gap-4 justify-between border-b pb-5">
					<div>
						<Typography type="semibold-18" className="font-semibold !text-lg">
							{title}
						</Typography>
						{subtitleCustom}
					</div>
					<div className="flex items-center gap-2 md:self-end">
						<Button
							decoration="secondary"
							size="medium"
							className="bg-white"
							onClick={onClickCancel}
							disabled={cancelDisabled}
						>
							Cancel
						</Button>
						<Button
							decoration="primary"
							size="medium"
							type="submit"
							disabled={saveDisabled}
						>
							Save
						</Button>
					</div>
				</div>
				<>{children}</>
			</form>
		</div>
	);
};
